import { Circle, Group, Text } from 'react-konva'
import { BaseElementBounds, Post2D } from '../../../models/Construction'
import { BaseComponentProps, BaseElementWrapper } from './EditorWrapper'
import { ElementInteractionCallbacks, FLOOR_PLAN_COLORS } from './Elements'

interface PostComponentProps extends BaseComponentProps<Post2D> {}

export const PostComponent: React.FC<PostComponentProps> = ({
  element,
  scale,
  thicknessMultiplier = 1,
  isSelected = false,
  onSelect,
  onDelete,
  onUpdate,
  onResizeStart,
}) => {
  const centerX = element.center_point.x * scale
  const centerY = element.center_point.y * scale
  const baseRadius =
    (Math.max(element.thickness, element.width) * scale * thicknessMultiplier) /
    2
  const radius = Math.max(3, baseRadius)

  const bounds: BaseElementBounds = {
    centerX,
    centerY,
    width: radius * 2,
    height: radius * 2,
    angle: 0,
  }

  const callbacks: ElementInteractionCallbacks<Post2D> = {
    onSelect,
    onDelete,
    onUpdate,
    onResizeStart,
  }

  const customColors = {
    normal: FLOOR_PLAN_COLORS.POSTS,
    hover: '#A9A9A9',
  }

  return (
    <BaseElementWrapper
      element={element}
      bounds={bounds}
      scale={scale}
      isSelected={isSelected}
      callbacks={callbacks}
      customColors={customColors}
      elementType='post'
    >
      {({ styling, behaviors, isHovered, dragProps }) => (
        <Group>
          <Circle
            x={centerX}
            y={centerY}
            radius={radius}
            {...styling}
            {...dragProps}
            onClick={behaviors.handleClick}
            onTap={behaviors.handleClick}
            onMouseEnter={behaviors.handleMouseEnter}
            onMouseLeave={behaviors.handleMouseLeave}
          />

          {(isHovered || isSelected) && (
            <Text
              x={centerX}
              y={centerY - radius - 15}
              text='POST'
              fontSize={8}
              fill='#2F4F4F'
              offsetX={12}
              offsetY={3}
              listening={false}
            />
          )}
        </Group>
      )}
    </BaseElementWrapper>
  )
}
